var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 4.66667L12.5885 12.7617C12.5386 13.4594 11.958 14 11.2585 14H5.74151C5.04199 14 4.46141 13.4594 4.41157 12.7617L3.83335 4.66667M10.5 4.66667V2.66667C10.5 2.29848 10.2015 2 9.83335 2H7.16669C6.7985 2 6.50002 2.29848 6.50002 2.66667V4.66667M3.16669 4.66667H13.8334",
    stroke: "#EF4444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTrash);
export default __webpack_public_path__ + "static/media/redTrash.efddabd6b5e6a2761c93d3a28fb0764c.svg";
export { ForwardRef as ReactComponent };